window.addEventListener("load", function () {
    const bubbleButton = document.querySelector('[data-oke-loyalty-widget] .c-launchBubble-button:not(.is-open)');
    
    if(bubbleButton) {
        bubbleButton.addEventListener('click', function (event) {
            const rewardsButton = document.querySelector('div#oke-rewards-widget .c-widget-content .c-widget-body > div:nth-child(2) .c-card:first-child > .c-actionButton:nth-child(2)'); 
            if(rewardsButton) {
              rewardsButton.click();  
            }
            
        })
    }
});